import { Component } from '@angular/core';
import { MatSelectionListChange } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'sfo-flags',
  templateUrl: './flags.component.html',
  standalone: false,
})
export class FlagsComponent {
  flags = [
    {
      name: 'export.debugPDF.enabled',
      title: 'Debug PDF',
      description: 'Include debug information in PDF exports (new engine)',
      get: (): boolean => localStorage.getItem('export.debugPDF.enabled') != undefined,
      set: (value: boolean) =>
        value
          ? localStorage.setItem('export.debugPDF.enabled', 'true')
          : localStorage.removeItem('export.debugPDF.enabled'),
    },
    {
      name: 'references.editing.enabled',
      title: 'Reference Editing',
      description: 'Enable editing of references',
      get: (): boolean => localStorage.getItem('references.editing.enabled') != undefined,
      set: (value: boolean) =>
        value
          ? localStorage.setItem('references.editing.enabled', 'true')
          : localStorage.removeItem('references.editing.enabled'),
    },
    {
      name: 'intelligence.enableProcessing',
      title: 'Enable Intelligence Processing',
      description: 'Run the intelligence pipeline when requested by the client',
      get: (): boolean =>
        localStorage.getItem('intelligence.enableProcessing') != undefined,
      set: (value: boolean) =>
        value
          ? localStorage.setItem('intelligence.enableProcessing', 'true')
          : localStorage.removeItem('intelligence.enableProcessing'),
    },
    {
      name: 'intelligence.disableCacheReads',
      parent: 'intelligence.enableProcessing',
      title: 'Disable Intelligence Cache Reads',
      description: 'Always run intelligence processing, never using cached results',
      get: (): boolean =>
        localStorage.getItem('intelligence.disableCacheReads') != undefined,
      set: (value: boolean) =>
        value
          ? localStorage.setItem('intelligence.disableCacheReads', 'true')
          : localStorage.removeItem('intelligence.disableCacheReads'),
      disabled: (): boolean =>
        localStorage.getItem('intelligence.enableProcessing') == undefined,
    },
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private snackBar: MatSnackBar,
  ) {
    if (this.route.snapshot.params?.id) {
      const flag = this.flags.find((f) => f.name.startsWith(this.route.snapshot.params.id));
      if (flag) {
        flag?.set(true);
        this.snackBar.open(flag.title + ' enabled', undefined, { duration: 5000 });
        this.router.navigateByUrl('/');
      } else {
        this.snackBar.open('Feature not found', undefined, { duration: 5000 });
        this.router.navigateByUrl('/');
      }
    }
  }

  change(event: MatSelectionListChange) {
    for (let option of event.options) {
      const flag = this.flags.find((f) => f.name === option.value);
      flag?.set(option.selected);
    }

    const aiProcessingEnabled = this.flags
      .find((f) => f.name === 'openai.intelligence.enableProcessing')
      ?.get();
    if (!aiProcessingEnabled) {
      this.flags.find((f) => f.name === 'openai.intelligence.disableCacheReads')?.set(false);
    }
  }
}
